export default __webpack_public_path__ + "static/media/GOOGLUSD.87dee8ea.svg";